import { render, staticRenderFns } from "./ProjectDescription.vue?vue&type=template&id=dcc5f71c&scoped=true"
import script from "./ProjectDescription.vue?vue&type=script&lang=ts"
export * from "./ProjectDescription.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDescription.vue?vue&type=style&index=0&id=dcc5f71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc5f71c",
  null
  
)

export default component.exports